export const FEATURE_FLAGS = Object.freeze({
  MANUAL_SUBMIT_MEETING: "manual-submit-meeting",
  CREATE_GOOGLE_MEETING: "create-google-meeting",
});
